import React, { Component } from "react";

export class QRCodeComponent extends Component<{ text: string, onClick?: () => void, width?: number | string }, {}> {
  qr;
  componentDidMount() {
    // @ts-ignore
    const qr = new QRCode(this.qr, {
      text: this.props.text,
      width: this.props.width || 150,
      height: this.props.width || 150,
    });
  }
  render() {
    const width = this.props.width || 150;
    return(<div onClick={this.props.onClick} style={{ width, height: width }} ref={(el) => this.qr = el} className="qrcode" />);
  }
}
